<template src="./Search.html"></template>
<style lang="scss" scoped src="./Search.scss"></style>

<script>

import Api from "@/api/Api";
import {clickOutside} from '@storefront-ui/vue/src/utilities/directives/click-outside/click-outside-directive.js';
import {OrkLoader, OrkProductCart} from "@/components/Ork";
import {
  SfCheckbox,
  SfRange,
  SfRadio,
  SfNotification,
  SfPagination,
  SfBreadcrumbs,
  SfDivider,
  SfHeading,
  SfSelect,
  SfButton,
  SfImage,
  SfIcon,
  SfScrollable,
  SfAccordion,
  SfSidebar,
  SfLoader,
  SfSearchBar,
  SfBar
} from '@storefront-ui/vue';
import ProductOptions from "@/utils/product_options";
import {LightProduct} from "@/models/product";
import {Pagination} from "@/models/pagination";
import SearchAutocomplete from '@/components/SearchAutocomplete';
import {icons} from "@/utils/icons";

export default {
  name: 'Search',
  data() {
    return {
      icons: icons,
      products: null,
      loading: false,
      notFirst: false,
      error: null,
      pagination: Pagination.of(null),
      sortBy: {options: ProductOptions.getProductOptions.sortAttributes, selected: process.env.VUE_APP_DEFAULT_SORT},
      sortOption: ProductOptions.getProductOptions.sortAttributes,
      breadcrumbs: [],
      searchTerm: null,
      searchTermFirst: null,
      searchTerms: [],
      showAutocomplete: false,
      debounceSearch: null,
      isFilterSidebarOpen: false,
      loadingSearch: false,
      loadingSearchFirst: false,
      loadingSearchNoResult: false,
      filters: null,
      currentFilters: null,
      selectedFilters: [],
      filteredPrice: [],
      scrollPosition: null,
      openedFilter: []
    };
  },
  directives: {clickOutside},
  components: {
    SfBar,
    SfCheckbox,
    SfAccordion,
    SfRadio,
    SfSearchBar,
    SearchAutocomplete,
    OrkProductCart,
    SfHeading,
    SfBreadcrumbs,
    SfPagination,
    SfButton,
    SfScrollable,
    SfImage,
    SfIcon,
    SfSelect,
    OrkLoader,
    SfDivider,
    SfSidebar,
    SfRange,
    SfLoader,
    SfNotification
  },
  computed: {},
  created() {
    this.searchTerm = this.$router.history.current.query.searchTerm
    this.filters = this.$router.history.current.query.filters
    this.setBreadcrumbs()
    this.searchProducts();
  },

  watch: {
    $route: 'searchProducts'
  },
  mounted() {
    window.addEventListener('scroll', this.updateScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.updateScroll);
  },
  methods: {
    updateScroll() {
      this.scrollPosition = window.scrollY;
      if (this.scrollPosition > 30) {
        document.body.classList.add("notTop");
      } else {
        document.body.classList.remove("notTop");
      }
    },
    isDisabled(filter, value) {
      /*
      if (this.currentFilters.length > 0) {
        let selected = this.currentFilters.find(f => f.filterName === filter.filterName && f.values.find(val => val === value))
        if (selected) {
          return false;
        }
      }*/
      return false
    },
    changeFilterPrice(filter, fetch) {

      let minPrice = Math.floor(Number(filter.value[0].replace(/\D+/g, '')))
      let maxPrice = Math.floor(Number(filter.value[1].replace(/\D+/g, '')))
      let isExist = this.selectedFilters.find(f => f.filterName === filter.filterName)
      let filterValue = '[>=' + minPrice + '||<=' + maxPrice + ']'
      if (!isExist) {

        this.selectedFilters.push({
          filterName: filter.filterName,
          value: filterValue,
          label: filter.label,
          type: filter.type,
          min: minPrice,
          max: maxPrice
        });

      } else {
        this.selectedFilters.map(f => {
          if (f.filterName === filter.filterName) {
            f.value = filterValue,
                f.min = minPrice,
                f.max = maxPrice
          }
        })
      }
      this.filteredPrice = [minPrice, maxPrice];
      if (!fetch)
        this.routerAddFilter();

    },
    removeFilters() {
      this.selectedFilters = [];
      this.filteredPrice = [];
      this.routerAddFilter();
    },
    removeFilter(filterToRemove) {
      if (filterToRemove.filterName === 'price') {
        this.filteredPrice = []
      }
      const index = this.selectedFilters.indexOf(filterToRemove);
      if (index > -1) {
        this.selectedFilters.splice(index, 1);
      }
      this.routerAddFilter();
    },

    removeFilterSingle(filterToRemove, value) {
      this.selectedFilters.map(selectFilter => {
        if (selectFilter.filterName === filterToRemove.filterName) {
          if (selectFilter.value.length > 0) {
            if (selectFilter.value.includes(value)) {
              selectFilter.value.splice(selectFilter.value.indexOf(value), 1);
              if (selectFilter.value.length === 0) {
                const index = this.selectedFilters.indexOf(filterToRemove);
                if (index > -1) {
                  this.selectedFilters.splice(index, 1);
                }
              }
            }
          }
        }
      })
      this.routerAddFilter();
    },

    changeFilterEnum(filter, fetch) {
      if (this.selectedFilters.length > 0) {
        let isExist = this.selectedFilters.find(f => f.filterName === filter.filterName)
        if (!isExist) {
          this.selectedFilters.push({
            filterName: filter.filterName,
            label: filter.label,
            type: filter.type,
            value: filter.value
          })
          return;
        }
        this.selectedFilters.map(f => {
          if (f.filterName === filter.filterName) {
            f.value = filter.value
          }
        })
      } else {
        this.selectedFilters.push({
          filterName: filter.filterName,
          label: filter.label,
          type: filter.type,
          value: filter.value
        })
      }
      if (!fetch)
        this.routerAddFilter();
    },
    formatArrayValue(value) {
      return '"' + value.join('","') + '"';
    },
    changeFilterMulti(filter, fetch) {
      if (this.selectedFilters.length > 0) {
        let isExist = this.selectedFilters.find(f => f.filterName === filter.filterName)
        if (!isExist) {
          if (Array.isArray(filter.value)) {
            this.selectedFilters.push({
              filterName: filter.filterName,
              label: filter.label,
              type: filter.type,
              value: filter.value
            });
          } else {
            this.selectedFilters.push({
              filterName: filter.filterName,
              label: filter.label,
              type: filter.type,
              value: [filter.value]
            });
          }
          if (!fetch)
            this.routerAddFilter();
          return;
        }
        this.selectedFilters.map(f => {
          if (f.filterName === filter.filterName) {
            if (Array.isArray(filter.value)) {
              filter.value.map((entry) => {
                if (!f.value.includes(entry)) {          //checking weather array contain the value
                  f.value.push(entry);               //adding to array because value doesnt exists
                }
              })
            } else {
              if (!f.value.includes(filter.value)) {          //checking weather array contain the value
                f.value.push(filter.value);               //adding to array because value doesnt exists
              } else {
                f.value.splice(f.value.indexOf(filter.value), 1);  //deleting
              }
            }
          }
          if (f.value.length === 0) {
            this.selectedFilters.splice(this.selectedFilters.indexOf(f), 1)
          }
        })
      } else {
        if (Array.isArray(filter.value)) {
          this.selectedFilters.push({
            filterName: filter.filterName,
            label: filter.label,
            type: filter.type,
            value: filter.value
          });
        } else {
          this.selectedFilters.push({
            filterName: filter.filterName,
            label: filter.label,
            type: filter.type,
            value: [filter.value]
          });
        }

      }
      if (!fetch)
        this.routerAddFilter();
    },

    routerAddFilter() {
      let sort = this.$router.history.current.query.sort;
      let page = this.$router.history.current.query.page;
      let itemsPerPage = this.$router.history.current.query.itemsPerPage;
      let filterQuery = '';
      if (this.selectedFilters.length > 0) {
        this.selectedFilters.forEach(function (filter, index, array) {

          if (index === array.length - 1) {
            if (filter.type === "MULTISELECT") {
              filterQuery += filter.filterName + ':' + '[' + filter.value.join('||') + ']'
            } else {
              filterQuery += filter.filterName + ':' + filter.value
            }
          } else {
            if (filter.type === "MULTISELECT") {
              filterQuery += filter.filterName + ':' + '[' + filter.value.join('||') + ']' + '&'
            } else {
              filterQuery += filter.filterName + ':' + filter.value + '&'
            }
          }
        })
        this.$router.replace({
          query: {
            searchTerm: this.searchTerm,
            filters: filterQuery,
            sort: sort,
            itemsPerPage: itemsPerPage
          }
        }).catch(() => {
          return null
        });
      } else {
        this.$router.replace({
          query: {
            searchTerm: this.searchTerm,
            sort: sort,
            page: page,
            itemsPerPage: itemsPerPage
          }
        }).catch(() => {
          return null
        });
      }

    },

    isSelectedEnum(filter) {
      if (this.selectedFilters.length > 0) {
        let selected = this.selectedFilters.find(f => f.filterName === filter.filterName && f.value === filter.value)
        if (selected) {
          return selected.value;
        }
      }
    },
    isSelectedMulti(filter) {
      if (this.selectedFilters.length > 0) {
        let selected = this.selectedFilters.find(f => f.filterName === filter.filterName && f.value?.find(val => val === filter.value))
        if (selected) {
          return true;
        }
      }
    },
    setBreadcrumbs() {

      this.breadcrumbs = [{
        text: this.$i18n.t('Home'),
        link: '/'
      }, {
        text: this.$i18n.t('Search'),
        link: '/recherche'
      }];

    },
    getLengthTerm(term) {
      let lengthTerm = 0;
      for (var i = 0, len = term.length; i < len; i++) {
        if (term[i] !== ' ')
          lengthTerm++;
      }
      return lengthTerm;
    },
    handleSearchAutoComplete(term) {

      clearTimeout(this.debounceSearch);
      this.searchTerm = term;
      if (this.getLengthTerm(this.searchTerm) >= 3) {

        this.debounceSearch = setTimeout(() => {
          this.loadingSearch = true;
          Api.product.searchAutocomplete(term).then((data) => {
            this.showAutocomplete = true;
            this.searchTerms = data;
          }).catch((e) => {
            this.$store.dispatch('sendNotification', {
              type: 'danger',
              message: this.$i18n.t('server error'),
              icon: icons.error
            });
          }).finally(() => {
            this.loadingSearch = false;
          })
        }, 500);
      }

    },
    handleNoResultSearchAutoComplete(term) {

      clearTimeout(this.debounceNoResultSearch);
      this.searchTerm = term;
      if (this.getLengthTerm(this.searchTerm) >= 3) {

        this.debounceNoResultSearch = setTimeout(() => {
          this.loadingSearchNoresult = true;
          Api.product.searchAutocomplete(term).then((data) => {
            this.showAutocomplete = true;
            this.searchTerms = data;
          }).catch((e) => {
            this.$store.dispatch('sendNotification', {
              type: 'danger',
              message: this.$i18n.t('server error'),
              icon: icons.error
            });
          }).finally(() => {
            this.loadingSearchNoresult = false;
          })
        }, 500);
      }

    },
    closeAutocomplete() {
      this.showAutocomplete = false;
    },
    handleFirstSearchAutoComplete(term) {
      clearTimeout(this.debounceFirstSearch);

      this.searchTermFirst = term;

      if (this.getLengthTerm(this.searchTermFirst) >= 3) {
        this.debounceFirstSearch = setTimeout(() => {
          this.loadingSearchFirst = true;
          Api.product.searchAutocomplete(term).then((data) => {
            this.showAutocomplete = true;
            this.searchTerms = data;
          }).catch((e) => {
            this.$store.dispatch('sendNotification', {
              type: 'danger',
              message: this.$i18n.t('server error'),
              icon: icons.error
            });
          }).finally(() => {
            this.loadingSearchFirst = false;

          })
        }, 500);
      }
    },
    changeSearchTerm(term) {
      this.searchTerm = term;
      this.showAutocomplete = false;
      this.notFirst = true
      if (this.getLengthTerm(this.searchTerm) >= 3) {

        this.$router.replace({query: {searchTerm: this.searchTerm}}).catch(() => {
          return null
        });
      }
      this.searchTerms = []
    },
    changeSorting(sort) {
      this.sortBy.selected = sort;
      ProductOptions.changeSorting(sort);
    },

    changeItemsPerPage(itemsPerPage) {
      this.pagination.itemsPerPage = parseInt(itemsPerPage);
      ProductOptions.changeItemsPerPage(itemsPerPage);
    },
    searchProducts() {

      this.searchTerm = this.$router.history.current.query.searchTerm || null;
      if (this.searchTerm && this.getLengthTerm(this.searchTerm) >= 3) {
        this.loadingSearch = true;
        let content = [];


        Api.product.searchPage(this.$router.history.current.query)
            .then(data => {
              this.pagination = Pagination.of(data.products);
              for (let lightProduct of data.products.content) {
                content.push(LightProduct.of(lightProduct));
              }
              if (data.filterableAttributes) {
                let currentFilters = Object.fromEntries(
                    Object.entries({...data.filterableAttributes}).sort(([keyA, a], [keyB, b]) => {

                      if (keyA === "afs_details_scale") {
                        a.values.sort((a, b) => b.substring(2) - a.substring(2));
                      } else {
                        a.values.sort(function (a, b) {
                          return a.localeCompare(b)
                        });
                      }

                      if (keyB === "afs_details_scale") {
                        b.values.sort((a, b) => b.substring(2) - a.substring(2));
                      } else {
                        b.values.sort(function (a, b) {
                          return a.localeCompare(b)
                        });
                      }

                      return a.label < b.label ? -1 : 1;
                    })
                );
                this.currentFilters = Object.keys(currentFilters).map((key) => currentFilters[key])
              }

              if (data.filterableAttributes) {
                this.filters = Object.fromEntries(
                    Object.entries({...data.filterableAttributes}).sort(([keyA, a], [keyB, b]) => {

                      if (keyA === "afs_details_scale") {
                        a.values.sort((a, b) => b.substring(2) - a.substring(2));
                      } else {
                        a.values.sort(function (a, b) {
                          return a.localeCompare(b)
                        });
                      }

                      if (keyB === "afs_details_scale") {
                        b.values.sort((a, b) => b.substring(2) - a.substring(2));
                      } else {
                        b.values.sort(function (a, b) {
                          return a.localeCompare(b)
                        });
                      }

                      return a.label < b.label ? -1 : 1;
                    }).sort(([keyA, a], [keyB, b]) => {
                      if (keyA === "price" || keyB === "price") {
                        this.openedFilter = [a.label]
                        return -1
                      }
                    })
                );

              }
              if (this.$router.history.current.query.filters) {
                let filtersQuery = this.$router.history.current.query.filters.split('&');
                let hasPrice = false;
                const openedFilter = []
                filtersQuery.map(f => {

                  let label = f.slice(0, f.indexOf(':'));
                  let value = f.slice(f.indexOf(':') + 1, f.length)
                  let val = [label, value]
                  let filter = {}
                  filter = {
                    label: this.filters[val[0]].label,
                    type: this.filters[val[0]].filterType,
                    filterName: val[0],
                  };
                  openedFilter.push(filter.label)
                  switch (this.filters[val[0]].filterType) {
                    case "MULTISELECT":
                      filter = {
                        label: this.filters[val[0]].label,
                        type: this.filters[val[0]].filterType,
                        filterName: val[0],
                        value: val[1].replaceAll(/\]|\[/gmi, '').split('||')
                      };
                      this.changeFilterMulti(filter, true)
                      break;
                    case"ENUMERATION":
                      filter = {
                        label: this.filters[val[0]].label,
                        type: this.filters[val[0]].filterType,
                        filterName: val[0],
                        value: val[1]
                      };
                      this.changeFilterEnum(filter, true)
                      break;
                    case "RANGE":
                      if (filter.filterName === 'price') {
                        this.filteredPrice = val[1].replaceAll(/<|>|=|\]|\[/gmi, '').split('||');
                        filter = {
                          label: this.filters[val[0]].label,
                          type: this.filters[val[0]].filterType,
                          filterName: val[0],
                          value: this.filteredPrice,
                          min: this.filteredPrice[0],
                          max: this.filteredPrice[1]
                        }

                        hasPrice = true
                        this.changeFilterPrice(filter, true)
                      }
                      break;
                  }
                })
                this.openedFilter = openedFilter
                if (!hasPrice) {
                  this.filteredPrice = []
                }
              } else {

              }
              this.products = content;

            })
            .catch((e) => {
              this.error = e;
            })
            .finally(() => {
                  this.notFirst = true;
                  this.loadingSearch = false;
                  this.isFilterSidebarOpen = false
                }
            );
      } else {
        this.notFirst = false;
        this.searchTerm = null;
        this.searchTermFirst = null;
        this.products = null;
      }
    },
  }

};
</script>

